/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Discord_Copy_FailedInputs */



/**
* | output |
* | --- |
* | "Couldn't copy the username" |
*
* @param {Discord_Copy_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const discord_copy_failed = /** @type {((inputs?: Discord_Copy_FailedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Discord_Copy_FailedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de copier le nom d'utilisateur")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo copiar el nombre de usuario")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não foi possível copiar o nome de usuário")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile copiare il nome utente")
	return /** @type {LocalizedString} */ ("Couldn't copy the username")
});